const Video = ({ src, width = '100%', height = '100%', preventDownload = true, preventContextMenu = true }) => {
  return (
    <div>
      <video
        src={src}
        controls
        controlsList={`${preventDownload ? 'nodownload' : ''}`}
        width={width}
        height={height}
        onContextMenu={preventContextMenu ? e => e.preventDefault() : null}
      ></video>
    </div>
  );
};

export default Video;
